import React from 'react';
import { Col, FormSelect } from 'react-bootstrap';

const FilterSelect = ({
  name,
  handleChange,
  defaultLabel,
  currentValue,
  payload,
}) => {
  return (
    <Col xs="auto p-0">
      <FormSelect
        name={name}
        onChange={handleChange}
        className="my-2"
        value={currentValue}
      >
        <option value="">{defaultLabel}</option>

        {payload.map((entity, index) => (
          <option key={`select-option-${index}`} value={entity.id}>
            {entity.value}
          </option>
        ))}
      </FormSelect>
    </Col>
  );
};

export default FilterSelect;
